import React from 'react';

export const withTestABComponent = (ComponentNew, ComponentOld) => props => {
  const { experiment } = props;

  if (experiment?.toUpperCase() === 'NEW') {
    return <ComponentNew {...props} />;
  }

  return <ComponentOld {...props} />;
};
